<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name:"CabinMonitoring",
  }
</script>

<style scoped>

</style>